<template>
  <div class="selcet-variant" v-if="show && dataLoaded">
    <div class="spv-info">
      <div class="close" @click="close">
        <div class="close-wrap j_close"></div>
      </div>

      <div class="spv" @click="showPreviewImage(spv.image)">
        <beast-image :src="spv.image" class="spv-img j_spv_img" />
        <div class="detail">
          <div class="brand">{{ spv.brand && spv.brand.name }}</div>
          <div class="name">{{ spv.name }}</div>
          <div class="bottom">
            <div class="price j_price">
              <price :data="spv.price"/>
              <div class="newn-tag" v-if="spv.newcomerTag">新人价</div>
            </div>
            
            <!-- <span class="count">X{{ count }}</span> -->
          </div>
          <div class="bottom" v-if="spv.point">
            <div class="point">兑换点数：{{spv.point}}</div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="content">
      <div class="variants">
        <div class="variants-item"  v-for="(i, variant_index) in data.variant.dimensions">
          <div class="group-title" v-if="data._dimensionGroup && data._dimensionGroup[variant_index]">{{data._dimensionGroup[variant_index]}}</div>
          <div class="title">{{ i.name }}</div>
          <div class="items">
              <div class="item" 
                v-for="(k, item_index) in i.choices" 
                @click="variantTap(variant_index, item_index)"
                :class="{ 
                  'disabled': variantMatrix.length && !variantMatrix[variant_index][item_index].available,
                  'on': variantMatrix.length && variantMatrix[variant_index][item_index].selected
                  }"
              >
                {{ k }}    
              </div>
          </div>
        </div>
      </div>

      <div class="variant-operation" v-if="data.selectAmount">
        <div class="title">数量</div>
        <div class="operation">
          <div class="sub j_sub" :class="{ disabled: count <= minCount }" @click="sub"></div>
          <div class="input"><input class="number j_input" v-model.number="count" type="number" @change="checkCount"/></div>
          <div class="add j_add" :class="{ disabled: count >= maxCount }" @click="add"></div>
        </div>
        <div class="tip">
          <template v-if="spv.minAmount && spv.minAmount > 1">
            {{ spv.minAmount }}件起售
          </template>
          <template v-if="spv.minAmount && spv.minAmount > 1 && spv.quota">
            ，
          </template>
          <template v-if="spv.quota">
            限购{{ spv.quota.total }}件
          </template>
          <template v-if="spv.quota && spv.quota.left > 0">
             , 还可买{{ spv.quota.left }}件
          </template>
          <template v-if="spv.quota && spv.quota.left <= 0">
             , 你已超限
          </template>
        </div>
      </div>
    </div>
    
    <div class="confirm-button-box" v-if="data.exchangeButton">
      <div class="confirm-text">可用点数：{{ data.myPoint }}</div>
      <div class="confirm-inner-button" :class="{ disabled: disabledConfirm }" @click="confirm">立即兑换</div>
    </div>
    <div class="confirm-button" :class="{ disabled: disabledConfirm || (spv.quota && spv.quota.left <= 0) }" @click="confirm" v-else>确定</div>
    
    <div class="preview" v-if="previewShow">
      <div class="back" @click="hidePrivew"><img src="https://img.thebeastshop.com/app/4.0/icon/beast-lesson/icon-back-arrow.png" /></div>
      <div class="preview-wrap">
        <swiper 
        :config="swiper"
        :paginateCls="swiper.paginateCls">
          <div class="swiper-slide" v-for="item in previewImgs">
            <img :src="item" />
          </div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
  import variantModel from '../lib/variant-model.js'
  import price from '@/price'
  import beastImage from '@/components/image'
  import Swiper from '@/swiper/swiper-4.4.6/index.vue'

  export default {
    name: 'selcet-variant',
    props: ['data', 'show'],
    data() {
      return {
        dataLoaded: false,
        spvId: null,
        spv: {
          brand: {
            name: null
          },
          name: null,
          price: null,
          minAmount: null,
          quota: null
        },
        oldCount: this.data.pack.count,
        count: this.data.pack.count,
        variantMatrix: [],
        disabledConfirm: false,
        minCount: null,
        maxCount: null,
        previewImgs: [],
        previewShow: false,
        swiper: {
          pagination: {
            el: '.swiper-pagination', 
            type: 'fraction',
          },
          spaceBetween: 30,
          centeredSlides: true,
          paginateCls: 'number-paginate',
          // autoplay: 3000,
          autoplayDisableOnInteraction: false
        }
      }
    },
    components: {
      price,
      beastImage,
      Swiper
    },
    created () {
      //at first time, get spvId from data.pack.spvId
      this.spv = this.getSpv(this.data.pack.variant)
      if(this.data.pack.product.point) {
        this.spv.point = this.data.pack.product.point
      }

      let availables = this.getAvailables(this.data.variant.spvs)
      
      this.model = new variantModel({
        availables: availables,
        dimensions: this.data.variant.dimensions,
        variant: this.data.pack.variant
      }).on('change', (result) => {
        this.count = 1
        this.updateData(result)
      })
    },
    methods: {
      close () {
        this.$emit('complete', null)
      },

      sub () {
        if (this.count <= this.minCount) {
          return
        }
        this.count--
      },

      add () {
        if (this.count >= this.maxCount) {
          return
        }
        this.count++
      },

      variantTap (variant_index, item_index) {
        let status = this.variantMatrix[variant_index][item_index]
        if (!status.available || status.selected) {
          return
        }
        this.model.select(item_index, variant_index)

        if(this.data.confirm) {
          this.confirm()
        }

         // todo 最后一行选
        const _dimension = this.variantMatrix
        const _length = _dimension.length
        if (variant_index == _length - 1) return

        let _ch_index = -1
      
        _dimension[_length - 1].forEach((choice, index)=> {
          if (_ch_index > -1 || !choice.available) return
          _ch_index = index
        })
        
        if (_ch_index === -1) return
        this.model.select(_ch_index, _length - 1)
      },

      updateData (result) {
        this.spvId = this.model.val()
    
        if (this.spvId) {
          this.spv = this.getSpv(this.spvId)
          if(this.data.pack.product.point) {
            this.spv.point = this.data.pack.product.point
          }
          this.maxCount = this.getMax(this.spv)
          this.minCount = this.spv.minAmount || 1
        }

        this.disabledConfirm = !result.done
        this.variantMatrix = result.matrix
        this.dataLoaded = true
      },

      checkCount () {
        let val = this.count
        if (val === '' || isNaN(val)) {
          this.count = this.oldCount
          return false
        }
        if (val > this.maxCount) {
          this.$toast('超过最大购买数量')
          this.oldCount = this.count = this.maxCount
          return false
        }
        if (val < this.minCount) {
          this.$toast(`最小购买数量为${this.minCount}`)
          this.oldCount = this.count = this.minCount
          return false
        }
        this.oldCount = this.count
        return true
      },

      getSpv (spvId) {
        return this.data.variant.spvs.filter((spv) => {
          return spv.id == spvId
        })[0] || {}
      },

      getAvailables (spvs) {
      return spvs.filter((spv) => {
          const max = this.getMax(spv)

          return spv.minAmount
          ? spv.minAmount <= max
          : max > 0
        })
      },

      getMax (spv) {
        return spv.quota
          ? Math.min(spv.left, spv.quota.left)
          : spv.left
      },

      showPreviewImage (curImage) {
        const spvImages = [curImage]

        this.data.variant.spvs.forEach(spv => {
          spvImages.push(spv.image)
        })
    
        this.previewImgs = spvImages
        this.previewShow = true
        
        const doc = document.querySelector('.beast_slider')

        doc.style.top = 0
      },

      hidePrivew () {
        this.previewShow = false
        this.previewImgs = []
        const doc = document.querySelector('.beast_slider')

        doc.style.top = 'auto'
      },

      confirm () {

        if (this.disabledConfirm || (this.spv.quota && this.spv.quota.left <= 0)) {
          return
        }
        this.$emit('complete', {
          spvId: this.spvId,
          count: this.count,
          price: this.spv.price,
          rawPrice: this.spv.rawPrice,
          pointPrice: this.spv.pointPrice
        })
      }
      // getMatrix (matrix) {
      //   let m = JSON.parse(JSON.stringify(matrix))
      //   this.dimensions.forEach((variant, variant_index) => {
      //     d.choices.forEach((item, item_index) => {
      //       m[variant_index][item_index].name = item
      //     })
      //   })
      //   return m
      // },
    },

  }

</script>

<style lang="stylus">
@import '../../../common/styl/global.styl'

.preview
  position fixed
  z-index 9999999
  top 0
  left 0
  right 0
  bottom 0
  background #000
  .back
    position absolute
    z-index 1000
    top rem(10)
    left rem(10)
    color #fff
    img
      width rem(22)
  .preview-wrap
    position absolute
    top rem(50)
    bottom rem(83)
    width rem(375)
    background #000
    .swiper-container
      position absolute
      top 50%
      transform translateY(-50%)
      overflow visible
      width rem(375)
      img
       width rem(375)
    .swiper-pagination
      top rem(-50)
      bottom auto
      width rem(375)
      font-size rem(17)
      color #fff

clearfix()
  &:after
    content ''
    font-size 0
    height 0
    line-height 0
    clear both
    display block
    visibility hidden
.slider 
  position absolute
  bottom 0
  left 0
  width 100%
  background #fff
.selcet-variant
  padding-top rem(102)
  .spv-info
    position absolute
    top 0
    left 0
    z-index 1
    width 100%
    .close
      position absolute
      right rem(10)
      top rem(10)
      z-index 2
      padding rem(5)
      .close-wrap
        width rem(12)
        height rem(12)
        position relative
        background url('//img.thebeastshop.com/apppictures/2017-06-23/f4be9c2662e8f0b08541b75cdcb66957.png')
        background-size 100% 100%
      // .close-icon
      //   position absolute
      //   top rem(11)
      //   left 0
      //   width rem(16)
      //   height rem(2)
      //   background #424648
      //   margin 0 auto
      //   transform rotateZ(45deg)
      //   &:after
      //     content ""
      //     background #424648
      //     display block
      //     width rem(16)
      //     height rem(2)
      //     position absolute
      //     top 0
      //     left 0
      //     transform rotateZ(90deg)
    .spv
      padding rem(22) rem(15) rem(10)
      border-top border-style
      border-bottom border-style
      clearfix()
      .spv-img
        float left
        width rem(65)
        height rem(68)
        display block
      .detail
        padding-left rem(12)
        float left
        .brand 
          ellipsis()
        .name,.brand
          font-size rem(13)
          width rem(230)
        .price 
          font-size rem(14)
          .newn-tag
            display inline-block
            width rem(42)
            height rem(17)
            margin-left rem(5)
            font-size rem(10)
            font-weight bold
            line-height rem(17)
            border-radius rem(2)
            text-align center
            background #F5F5F5
            color #DD4F14
            &::before
              content ''
              display inline-block
              vertical-align middle
              width 0
              height 100%
              margin-top rem(1)
        .count
          font-size rem(13)
        .name 
          height rem(34)
          line-height rem(17)
          overflow hidden
      .label
        font-size rem(12)
  .variant-operation
    font-size rem(14)
    padding rem(10) 0 rem(25) rem(15)
    clearfix()
    .title
      width rem(32)
      float left
      line-height rem(40)
    .operation
      float left
      height rem(40)
      border border-style
      margin-left rem(8)
      clearfix()
      .add,.sub
        float left
        width rem(45)
        height 100%
        position relative
      .add
        border-left 1px solid #E6E7E8
      .sub
        border-right 1px solid #E6E7E8
      .add::before,.sub::before,.add::after
        content ''
        display block
        width rem(15)
        height rem(2)
        background #2b2b2b
        position absolute
        transform translate(-50%, -50%)
        top 50%
        left 50%
      .add::after
        width rem(2)
        height rem(15)
      .add.disabled, .sub.disabled
        &::before, &::after
          opacity 0.3
        
      .input
        width rem(70)
        float left
        height 100%
        position relative
        .number
          width 100%
          height 100%
          text-align center
          border 0
          box-sizing border-box
    .tip
      color #000
      font-size rem(13)
      float left
      margin-left rem(10)
      line-height rem(40)
  .content
    padding rem(25) 0 rem(60)
    max-height rem(400)
    overflow scroll
    -webkit-overflow-scrolling touch
    .variants
      font-size rem(14)
      .variants-item
        padding 0 rem(83) rem(15) rem(15)
        .group-title
          font-weight bold
          font-size rem(16)
          margin-bottom rem(10)
        .title
          padding-bottom rem(10)
        .items
          width rem(292)
          clearfix()
          .item
            margin 0 rem(15) rem(15) 0
            float left
            padding rem(6) rem(20)
            background background-color
            max-width rem(254)
            &.on
              color #fff
              background #000
            &.disabled
              opacity 0.3

  .confirm-button
    position absolute
    bottom 0
    left 0
    font-size rem(16)
    color #fff
    text-align center
    padding rem(14) 0
    background #000
    width 100%
    z-index 2
    &.disabled
      opacity 0.3
  .confirm-button-box
    position absolute
    bottom 0
    left 0
    width 100%
    height rem(64)
    padding rem(10) rem(10) rem(10) rem(15)
    background #ffffff
    box-sizing border-box
    border-top 1px solid #e6e7e8
    clearfix()
    .confirm-text
      float left
      height rem(44)
      line-height rem(44)
      color #000000
      font-size rem(14)
      font-weight bold
    .confirm-inner-button
      float right
      width rem(120)
      height rem(44)
      line-height rem(44)
      border-radius rem(2)
      color #ffffff
      font-size rem(15)
      font-weight bold
      background #000000
      text-align center
      &.disabled
        opacity 0.3



</style>


// WEBPACK FOOTER //
// index.vue?d47fec02